import request from '@/utils/request'

// 列表
export function fetchList(data) {
    return request({
        url: '/oms/shopee/order/list',
        method: 'post',
        data: data
    })
}

// 审单
export function syncOrder(shopeeOrderSn){
	return request({
		url: `/oms/shopee/order/check?shopeeOrderSn=${shopeeOrderSn}`,
		method: 'get'
	})
}

//店铺列表
export function listShop(){
	return request({
		url: `/oms/shopee/shop/list`,
		method: 'get'
	})
}

//订单导入
export function importOrder(data) {
	return request({
		url: '/oms/order/import',
		method: 'POST',
		data
	})
}


// 订单详情
export function getOrderDetail(shopeeOrderSn) {
    return request({
        url: `/oms/shopee/order/detail?shopeeOrderSn=${shopeeOrderSn}`,
        method: 'get'
    })
}

// 到货单详情
export function getOrderDetailByOrderSn(orderSn) {
    return request({
        url: `/oms/omsOrder/shopify/${orderSn}`,
        method: 'get'
    })
}

export function getOrderSku(orderSn) {
    return request({
        url: `/oms/omsOrder/orderSn/${orderSn}`,
        method: 'get'
    })
}

// 打印拣货单
export function printOrderDelivery(data) {
    return request({
        url: '/oms/omsOrder/printOrderDelivery',
		method: 'post',
		params: data
    })
}

// 打印面单
export function printDeliveryorder(id) {
    return request({
        url: `/oms/omsOrder/printDeliveryOrder/${id}`,
		method: 'get'
    })
}

// 补打面单
export function rePrintDeliveryorder(orderSn) {
	return request({
		url: `/oms/order/getExpressInfo?orderSn=${orderSn}`,
		method: 'get'
	})
}

export function updateShippingAddress(data) {
    return request({
        url: '/oms/order/address/update',
        method: 'post',
        data: data
    })
}

// 状态字典
export function orderDictList(data) {
    return request({
        url: '/oms/orderDict/list',
        method: 'get',
        params: data
    })
}

// 到仓签收  sn sn为DHD打头的到货单号
export function orderReceived(data) {
    return request({
        url: '/scm/deliverOrder/received',
        method: 'post',
        data:data
    })
}

//订单减少商品
export function decreaseGoods(data){
	return request({
		url: `/oms/order/goods/decrease`,
		method: 'post',
		data:data
	})
}

//订单同商品换货
export function replaceGoods(data){
	return request({
		url: `/oms/order/goods/replace`,
		method: 'post',
		data:data
	})
}



// WEBPACK FOOTER //
// ./src/api/oms/shopee-order.js